import { useQuery } from '@tanstack/react-query';
import { fetchFortune, todayInJst } from '../lib/apiClient';
import type { PeriodKind, FortuneApiResponse } from '../lib/types';

export function useFortune(period: PeriodKind, date: string = todayInJst()) {
  return useQuery<FortuneApiResponse, Error>({
    queryKey: ['fortune', period, date, '1963-06-19'],
    queryFn: ({ signal }) => fetchFortune({ period, date, signal }),
    // 期間境界を越えるまでは新鮮扱い。境界の管理は API 側で行う。
    staleTime: 10 * 60 * 1000,
  });
}
